import { Component } from 'react';
import {AuthContext} from "../context/auth";

class SharedDealComponent extends Component{
    static contextType = AuthContext;

    componentDidMount(){
        window.scrollTo(0, 0)
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const deal_type = params.get('deal_type');
        const AddToShare = { 'deal_id': this.props.match.params.deal_id, 'deal_type': deal_type };
        if(deal_type === 'allday') {
            if(!this.context.authenticated)
                localStorage.setItem('silverbackAddToShare', JSON.stringify(AddToShare));
            this.props.history.push(process.env.PUBLIC_URL + '/allday/deal/' + this.props.match.params.deal_id);
        }
        else if(deal_type === 'oneday') {
            if(!this.context.authenticated)
                localStorage.setItem('silverbackAddToShare', JSON.stringify(AddToShare));
            this.props.history.push(process.env.PUBLIC_URL + '/oneday/deal/' + this.props.match.params.deal_id);
        }
        else
            this.props.history.push(process.env.PUBLIC_URL+'/404');
    }

    render(){
        return null
    }
}

export default SharedDealComponent;